<template>
  <net-popup-menu
    class="relation-draft-popup-menu"
    :height="280"
    :width="250"
    :offset-x="-125"
    :offset-y="-280"
  >
    <template #title>
      <template v-if="updateType == 'none'">
        {{ $t("actions.createNonImpact") }}
      </template>
      <template v-else>
        {{ $t("actions.createImpact") }}
      </template>
    </template>

    <input-dropdown
      v-slot="{ item: type }"
      v-model:value="updateType"
      :options="availableUpdateTypes"
      :label="$t('labels.relationUpdateType')"
    >
      {{ $t(`relationUpdateTypes.${type}`) }}
    </input-dropdown>

    <!-- <input-texteditor
      v-if="ctx.endItem != null"
      :label="$t('labels.description')"
      :value="description"
      @update:value="description = $event"
    /> -->
    <template v-if="ctx.endElement != null">
      <div v-if="updateType == 'change'">
        <h4 class="label mt-0">{{ $t("labels.effect") }}</h4>
        <div class="list mt-2">
          <input-radio
            :value="transmissionType"
            icon="not-inverse"
            data="standard"
            :label="$t('labels.relationStandard')"
            @update:value="transmissionType = $event"
          />
          <input-radio
            :value="transmissionType"
            data="inverse"
            icon="inverse"
            :label="$t('labels.relationInverse')"
            @update:value="transmissionType = $event"
          />
        </div>
      </div>

      <button class="button" type="button" @click="createRelation()">
        <template v-if="updateType == 'none'">
          {{ $t("actions.createNonImpact")}}
        </template>
        <template v-else>
          {{ $t("labels.createRelation") }}
        </template>
      </button>
    </template>
    <template v-else>
      <p class="message mt-0">
        {{ $t("messages.chooseElement") }}
      </p>
    </template>
  </net-popup-menu>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRelationBuilder } from "./relationBuilder.js";

import NetPopupMenu from "@editor/net/NetPopupMenu.vue";
import InputRadio from "@core/input/RadioButton.vue";
import InputDropdown from "@core/input/InputDropdown.vue";

import { useRelationStore } from "@editor/items/relation/relations.store";
import { useSelectionStore } from "@editor/store/editor/selection.store";

const ctx = useRelationBuilder();

const relationStore = useRelationStore();
const selectionStore = useSelectionStore();

const transmissionType = computed({
  get() {
    return ctx.relationDraft?.transmissionType ?? "standard";
  },
  set(value: string) {
    if (ctx.relationDraftId == null) {
      console.warn("no relation draft id.");
      return;
    }
    if (!ctx.relationDraft) {
      ctx.relationDrafts[ctx.relationDraftId] = {
        transmissionType: value,
        updateType: "change",
        description: ""
      };
    } else {
      ctx.relationDraft.transmissionType = value;
    }
  }
});

// const description = computed({
//   get() {
//     return ctx.relationDraft?.description ?? "";
//   },
//   set(value: string) {
//     if (!ctx.relationDraft) {
//       if (ctx.relationDraftId == null) {
//         console.warn("no relation draft id.");
//         return;
//       }
//       ctx.relationDrafts[ctx.relationDraftId] = {
//         transmissionType: "standard",
//         updateType: "change",
//         description: value
//       };
//     } else {
//       ctx.relationDraft.description = value;
//     }
//   }
// });

const availableUpdateTypes = computed(() => {
  return ["change", "none"];
});

const updateType = computed({
  get() {
    const updateType = ctx.relationDraft?.updateType;
    if (updateType != "change" && updateType != "none") return "change";
    return updateType ?? "change";
  },
  set(value: "change" | "none") {
    if (!ctx.relationDraft) {
      if (ctx.relationDraftId == null) {
        console.warn("no relation draft id.");
        return;
      }
      ctx.relationDrafts[ctx.relationDraftId] = {
        transmissionType: "standard",
        updateType: value,
        description: ""
      };
    } else {
      ctx.relationDraft.updateType = value;
    }
  }
});

async function createRelation() {
  let inverse = transmissionType.value === "inverse";
  if (ctx.baseElement == null) {
    console.warn("can't create relation without base item.");
    return;
  }
  if (ctx.endElement == null) {
    console.warn("can't create relation without end item.");
    return;
  }

  const relationData = {
    startItemId: ctx.baseElement.id,
    startItemType: ctx.baseElement.type,
    endItemId: ctx.endElement.id,
    endItemType: ctx.endElement.type,
    inverse: inverse,
    description: "", // description.value,
    updateType: updateType.value
  };
  const relation = await relationStore.create(relationData);

  ctx.exitRelationBuilder();
  selectionStore.clearAll();
  selectionStore.select(relation);

  return relation;
}
</script>

<style>
.relation-draft-popup-menu {
  transform-origin: center bottom;
}
</style>
